// Cấu hình phạt NỢ ĐỒ quá hạn theo nấc (CONFIG_ITEM_DEBT_PENALTY). Giữ ĐỒNG BỘ với cron phía order service
// (`ItemDebtOverdueService`).
//  - NV giặt của đơn LUÔN bị phạt ở mọi nấc — không cấu hình ở đây.
//  - Mỗi nấc thêm: bộ phận + cá nhân chỉ định; chỉ người thuộc CHI NHÁNH SẢN XUẤT của đơn mới bị phạt.
//  - Điểm phạt dùng chung "Nợ đồ quá hạn" trong bảng điểm (CONFIG_FAULT_PENALTY) cho cả 3 nấc.
//  - Khoảng nhảy nấc = 0 → chỉ phạt nấc 1.

export const ITEM_DEBT_MAX_LEVEL = 3;

export interface ItemDebtPenaltyUser {
  id: number;
  name: string;
}

export interface ItemDebtPenaltyLevel {
  department_ids: number[];
  // Lưu kèm tên để hiển thị lại mà không phải tra từng người (BE chỉ đọc id).
  users: ItemDebtPenaltyUser[];
}

export interface ItemDebtPenaltyConfig {
  escalation_interval_hours: number;
  levels: ItemDebtPenaltyLevel[]; // luôn đủ ITEM_DEBT_MAX_LEVEL phần tử trên UI
}

const emptyLevels = (): ItemDebtPenaltyLevel[] =>
  Array.from({ length: ITEM_DEBT_MAX_LEVEL }, () => ({ department_ids: [], users: [] }));

export function defaultItemDebtPenaltyConfig(): ItemDebtPenaltyConfig {
  return { escalation_interval_hours: 0, levels: emptyLevels() };
}

/** Parse chuỗi JSON từ setting → config đủ 3 nấc (thiếu/hỏng → mặc định). */
export function parseItemDebtPenaltyConfig(raw: string | undefined | null): ItemDebtPenaltyConfig {
  const base = defaultItemDebtPenaltyConfig();
  if (!raw) return base;
  try {
    const obj = JSON.parse(raw) as Partial<ItemDebtPenaltyConfig>;
    base.escalation_interval_hours = Math.max(0, Number(obj?.escalation_interval_hours) || 0);
    (obj?.levels || []).slice(0, ITEM_DEBT_MAX_LEVEL).forEach((lv, i) => {
      base.levels[i] = {
        department_ids: Array.isArray(lv?.department_ids) ? lv.department_ids.map(Number).filter(Boolean) : [],
        users: Array.isArray(lv?.users)
          ? lv.users
              .map((u) => ({ id: Number(u?.id), name: String(u?.name || "") }))
              .filter((u) => u.id > 0)
          : [],
      };
    });
  } catch {
    /* raw hỏng → dùng mặc định */
  }
  return base;
}

/** Chuẩn hoá config → JSON để lưu setting. Giữ đủ 3 nấc để không lệch thứ tự nấc. */
export function serializeItemDebtPenaltyConfig(cfg: ItemDebtPenaltyConfig): string {
  return JSON.stringify({
    escalation_interval_hours: Math.max(0, Number(cfg.escalation_interval_hours) || 0),
    levels: cfg.levels.slice(0, ITEM_DEBT_MAX_LEVEL).map((lv) => ({
      department_ids: (lv.department_ids || []).filter(Boolean),
      users: (lv.users || []).filter((u) => u.id > 0).map((u) => ({ id: u.id, name: u.name })),
    })),
  });
}
